import { type CacheAnalyticsCallback } from '../../../utils/caching/persist-refresh';
import { type DegradationCallback } from '../../utils/degradable-promise';

import { RIGHT_PANEL_TRAIT } from './constants';
import { fetchUserPersonalizationBySiteUser, parseRecommendations } from './core';

export const getRightPanelRecommendations = async ({
	userId,
	analyticsCallback,
	degradationCallback,
}: {
	userId: string;
	analyticsCallback?: CacheAnalyticsCallback;
	degradationCallback?: DegradationCallback;
}): Promise<string[]> => {
	if (!userId) {
		return [];
	}
	const trait = await fetchUserPersonalizationBySiteUser({
		userId,
		analyticsCallback,
		degradationCallback,
		cacheKeySuffix: 'right-panel',
		traitName: RIGHT_PANEL_TRAIT,
	});

	return parseRecommendations(RIGHT_PANEL_TRAIT, trait);
};
